<!-- flex box parent -->
<div
  *ngIf="!!entity"
  class="action-wrapper"
  [style]="{ 'flex-flow': orientation === 'vertical' ? 'column wrap' : 'row wrap' }"
>
  <ng-container *ngFor="let action of entity._actions_" [ngSwitch]="action">
    <ng-container *ngSwitchCase="'UPDATE'">
      <p-button
        type="button"
        icon="pi pi-pencil"
        [class]="[orientation === 'vertical' ? 'action-button-vertical' : 'action-button']"
        label="Bearbeiten"
        (click)="updateEntity()"
      >
      </p-button>
    </ng-container>

    <ng-container *ngSwitchCase="'DELETE'">
      <p-button
        type="button"
        icon="pi pi-trash"
        [class]="[orientation === 'vertical' ? 'action-button-vertical' : 'action-button']"
        label="Löschen"
        (click)="deleteEntity()"
      >
      </p-button>
    </ng-container>

    <!-- backend only sends this string if conditions to execute this action are met, no gui checks needed -->
    <ng-container *ngSwitchCase="'ADJUST_STATE_ACTION'" [jmlVar]="{ inProgress: false }" #actionButton="jmlVar">
      <p-button
        type="button"
        icon="fa fa-crosshairs"
        [class]="[orientation === 'vertical' ? 'action-button-vertical' : 'action-button']"
        label="Zustand korrigieren"
        [disabled]="actionButton.inProgress"
        (onClick)="performAction('ADJUST_STATE_ACTION', actionButton)"
      >
      </p-button>
    </ng-container>

    <p-button
      *ngSwitchDefault
      type="button"
      [jmlVar]="{ inProgress: false }"
      #actionButton="jmlVar"
      [icon]="configuration.actions[action].icon"
      [class]="[orientation === 'vertical' ? 'action-button-vertical' : 'action-button']"
      [disabled]="actionButton.inProgress"
      [label]="configuration.actions[action].tooltip"
      (click)="performAction(configuration.actions[action].hrid, actionButton)"
    >
    </p-button>
  </ng-container>
</div>
